<template>
  <template v-if="!isSellEnded">
    <div class="add-to-cart" data-vue-add-to-cart>
      <input
        v-if="showQtyInput"
        type="number"
        v-model="qtyIncr"
        min="1"
        step="1"
      />
      <span class="add-to-cart-btn-wrapper" :title="buttonTooltip || null">
        <button
          type="button"
          :class="[
            'add-to-cart-btn',
            isSelectOfferMode ? 'select-offer-btn' : '',
          ]"
          :disabled="forceDisabled"
          @click.prevent="(event) => addToCartAction(event)"
        >
          {{ btnlabel ? btnlabel : $t("labels.addToCart") }}
        </button>
      </span>
    </div>
  </template>
  <template v-else>
    <div class="add-to-cart-ended">
      {{ $t("labels.sellEnded") }}
    </div>
  </template>
</template>

<script>
import CartService from "@/services/cart";
import { useDraftStore } from "@/store/draft";
import ProductService from "@/services/product";
import FetchFile from "@/services/fetchFile";
import { useCartStore } from "@/store/cart";

export default {
  name: "AddToCart",
  props: {
    item: Object,
    showqty: Boolean,
    changeChoice: Object,
    btnlabel: String,
    isfromstaticpage: Boolean,
    productexternalid: String,
    choiceexternalid: String,
    productinfos: String,
    forceDisabled: {
      type: Boolean,
      default: false,
    },
    disabledTooltip: {
      type: String,
      default: "",
    },
  },
  computed: {
    buttonTooltip() {
      if (!this.forceDisabled || !this.disabledTooltip) {
        return "";
      }

      return this.disabledTooltip;
    },
    isSelectOfferMode() {
      return (
        !this.isfromstaticpage &&
        window?.productDetails?.limitCartTo1Item === true
      );
    },
    // Sur order page (radio ou panier), la quantite se regle uniquement
    // dans OrderSummary — pas au moment du "+ Ajouter".
    showQtyInput() {
      return (
        this.showqty &&
        this.shopAllowQtyModification &&
        window?.globalConfig?.isOrderPage !== true
      );
    },
  },
  data() {
    return {
      productDetails: {},
      isSellEnded: false,
      intervalSellEnded: null,
      shopAllowQtyModification: false,
      qtyIncr: 1,
    };
  },
  mounted() {
    if (!this.isfromstaticpage) {
      this.productDetails = window.productDetails;
      if (this.productDetails?.endDate) {
        this.isSellEnded = this.productDetails.endDate <= Date.now();
        this.intervalSellEnded = setInterval(() => {
          this.isSellEnded = this.productDetails.endDate <= Date.now();
        }, 1000);
      }
      this.shopAllowQtyModification =
        !!window.globalConfig.shopAllowQtyModification;
    }
  },
  beforeDestroy() {
    if (this.intervalSellEnded) {
      clearInterval(this.intervalSellEnded);
    }
  },
  methods: {
    async addToCartAction(event) {
      if (this.forceDisabled) {
        return;
      }

      // Only limit cart to 1 item if it's not a post-upsell
      if (
        this.productDetails &&
        this.productDetails.limitCartTo1Item &&
        !this.item?.isPostUpsell
      ) {
        if (useCartStore().cart.items.length > 0) {
          CartService.emptyCart();
        }
      }

      if (this.item) {
        // product list
        this.item.qtyIncr = this.qtyIncr;
        if (this.changeChoice) {
          this.item.qty = 0; // change of choice, reset qty
          this.item.choice = this.changeChoice;
        } else if (!this.item.choice?.id) {
          this.item.choice = ProductService.getDefaultChoice(this.item);
        }
        CartService.addToCart(this.item);
      } else if (this.productDetails) {
        // product view
        if (this.isfromstaticpage) {
          await this.getProductDetails();
          console.log("this.productDetails", this.productDetails);
        }

        const productToAdd = Object.assign({}, this.productDetails);
        productToAdd.qtyIncr = this.qtyIncr;
        const selectedChoiceId = useDraftStore().selectedChoice;

        if (selectedChoiceId) {
          productToAdd.choice = this.productDetails.choices.find(
            (choice) => choice.id === selectedChoiceId,
          );

          CartService.addToCart(productToAdd);
        } else {
          console.error("You need to choose a choice");
        }
      }
    },
    async getProductDetails() {
      const productExternalId =
        this.productexternalid || window.productExternalId;
      const choiceExternalId = this.choiceexternalid || window.choiceExternalId;
      const productInfos = this.productinfos || window.productInfos;
      const data = await new Promise((resolve, reject) => {
        new FetchFile().fetch(
          `/data/products/${productExternalId}.json`,
          ({ data }) => {
            resolve(data);
          },
          reject,
        );
      });

      this.productDetails = data;
      this.productDetails.choices.forEach((choice) => {
        if (choice.id === choiceExternalId) {
          useDraftStore().selectChoice(choice.id);
        }
      });
      if (productInfos) {
        this.productDetails.productInfos = productInfos;
      }
    },
  },
};
</script>

<style scoped>
.add-to-cart-btn-wrapper {
  display: inline-block;
  width: 100%;
}

.add-to-cart-btn-wrapper[title] {
  cursor: not-allowed;
}

.add-to-cart-btn-wrapper[title] .add-to-cart-btn {
  pointer-events: none;
}

.add-to-cart-btn:disabled {
  background-color: #b9b9b9;
  border-color: #b9b9b9;
  border-bottom-color: #959595;
  color: #6a6a6a;
  cursor: not-allowed;
}

/* "Sélectionner cette offre" mode — more prominent */
.select-offer-btn {
  width: 100%;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  letter-spacing: 0.02em;
  transition:
    transform 0.1s ease,
    box-shadow 0.1s ease;
}
.select-offer-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}
</style>
